module.exports = __webpack_public_path__ + "img/img-top.fa2825a3.png";